<prism-dialog id="sh-about-dialog" [visible]="true" *transloco="let t">
	<span slot="dialog-title" id="sh-about-dialog-h1-title">{{ t(data.title) }}</span>

	<div id="sh-about-dialog-content">
		<p id="sh-about-dialog-p-version">{{ t('cloud.shared.about-dialog.version') }} - {{ version }}</p>
		<p *ngIf="clientVersion" id="sh-about-dialog-client-version">
			{{ t('cloud.shared.about-dialog.client-version') }} - {{ clientVersion }}
		</p>
		<p id="sh-about-dialog-p-rights">
			{{ t('cloud.shared.about-dialog.shure-rights', { toDate: currentYear }) }}
		</p>
		@if (showDebugMode && isDebugModeEnabledForApplication) {
			<prism-checkbox
				id="sh-about-dialog-checkbox"
				(click)="$event.stopPropagation()"
				[checked]="isChecked"
				(valueChange)="onSelectionChanged($event.detail)"
			>
				{{ t('cloud.shared.about-dialog.enable-debug-mode') }}
			</prism-checkbox>
		}
	</div>

	<div slot="dialog-footer-buttons" id="sh-assign-confirm-action-buttons">
		<prism-button id="sh-about-dialog-button-close" (click)="closeDialog()">
			{{ t('cloud.shared.about-dialog.close') }}
		</prism-button>
	</div>
</prism-dialog>
